import React from 'react';
import { Box, Typography, TextField, Button } from '@material-ui/core';

const BLUE = '#1025a2';
const YELLOW = '#ffde59';
const YELLOW_HOVER = '#ffd11a';
const WHITE = '#ffffff';

export default class ReAuthTOTP extends React.Component {
  state = {
    totpCode: '',
    isVerifying: false,
    error: '',
  };

  handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    this.setState({ totpCode: value, error: '' });
  };

  handleVerify = async () => {
    console.log('=== ReAuthTOTP.handleVerify CLICKED ===', new Date().toISOString());
    if (this.state.totpCode.length !== 6) {
      console.log('ReAuthTOTP: code length invalid:', this.state.totpCode.length);
      return;
    }
    this.setState({ isVerifying: true, error: '' });
    try {
      await this.props.onVerifyTOTP(this.state.totpCode);
    } catch (err) {
      this.setState({ error: err.message || 'Invalid code. Please try again.' });
    } finally {
      this.setState({ isVerifying: false });
    }
  };

  render() {
    const { totpEnabled } = this.props;

    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        style={{ backgroundColor: BLUE }}
        p={3}
      >
        {/* ME-VISION header bar */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            marginBottom: '32px',
          }}
        >
          {/* Logo spiral placeholder — matches the yellow arrow/spiral in the image */}
          <Box
            style={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              backgroundColor: YELLOW,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 16,
              fontSize: 28,
            }}
          >
            🔄
          </Box>

          {/* Vertical divider */}
          <Box
            style={{
              width: 3,
              height: 56,
              backgroundColor: WHITE,
              marginRight: 16,
              opacity: 0.6,
            }}
          />

          {/* Brand name and tagline — yellow arrow shape via clip-path */}
          <Box
            style={{
              backgroundColor: YELLOW,
              padding: '10px 28px 10px 20px',
              clipPath: 'polygon(0 0, 92% 0, 100% 50%, 92% 100%, 0 100%)',
              textAlign: 'left',
            }}
          >
            <Typography
              style={{
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 900,
                fontSize: '1.3rem',
                color: BLUE,
                letterSpacing: '1px',
                lineHeight: 1.1,
              }}
            >
              ME-VISION
            </Typography>
            <Typography
              style={{
                fontFamily: 'Roboto, sans-serif',
                fontSize: '0.65rem',
                color: BLUE,
                lineHeight: 1.3,
              }}
            >
              Purpose-Driven Individuals.<br />
              Successful Leaders.
            </Typography>
          </Box>
        </Box>

        {/* TOTP card */}
        <Box
          style={{
            backgroundColor: WHITE,
            padding: '36px 32px',
            borderRadius: '4px',
            maxWidth: '400px',
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
            borderTop: `6px solid ${YELLOW}`,
          }}
        >
          <Typography
            variant="h6"
            style={{
              color: BLUE,
              fontWeight: 800,
              marginBottom: '8px',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              fontSize: '1rem',
            }}
          >
            Session Verification
          </Typography>

          <Typography
            variant="body2"
            style={{
              color: '#555',
              marginBottom: '28px',
              lineHeight: 1.6,
              fontSize: '0.88rem',
            }}
          >
            Your session has been inactive for a while.<br />
            Enter your Google Authenticator code to continue.
          </Typography>

          {!totpEnabled ? (
            <Box
              style={{
                backgroundColor: '#fff8e1',
                border: `1px solid ${YELLOW}`,
                padding: '16px',
                borderRadius: '4px',
                marginBottom: '20px',
              }}
            >
              <Typography style={{ color: BLUE, fontSize: '0.85rem' }}>
                Google Authenticator is not enabled for your account.
                Please enable it in your Security settings.
              </Typography>
            </Box>
          ) : (
            <>
              <TextField
                fullWidth
                value={this.state.totpCode}
                onChange={this.handleCodeChange}
                onKeyPress={(e) => e.key === 'Enter' && this.handleVerify()}
                inputProps={{
                  maxLength: 6,
                  style: {
                    fontSize: '32px',
                    letterSpacing: '14px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    color: BLUE,
                    padding: '14px 0',
                  }
                }}
                placeholder="000000"
                variant="outlined"
                margin="normal"
                style={{ marginBottom: '4px' }}
                InputProps={{
                  style: {
                    borderRadius: '4px',
                  }
                }}
              />

              <Typography
                variant="caption"
                style={{ color: '#888', display: 'block', marginBottom: '16px' }}
              >
                Open Google Authenticator and enter the 6-digit code
              </Typography>

              {this.state.error && (
                <Box
                  style={{
                    backgroundColor: '#ffebee',
                    border: '1px solid #ef9a9a',
                    borderRadius: '4px',
                    padding: '10px 14px',
                    marginBottom: '16px',
                  }}
                >
                  <Typography
                    style={{ color: '#c62828', fontSize: '0.85rem' }}
                  >
                    {this.state.error}
                  </Typography>
                </Box>
              )}

              <Button
                variant="contained"
                fullWidth
                onClick={this.handleVerify}
                disabled={this.state.totpCode.length !== 6 || this.state.isVerifying}
                style={{
                  marginTop: '8px',
                  padding: '14px',
                  fontSize: '15px',
                  fontWeight: 'bold',
                  backgroundColor: this.state.totpCode.length !== 6 || this.state.isVerifying
                    ? '#ccc'
                    : YELLOW,
                  color: this.state.totpCode.length !== 6 || this.state.isVerifying
                    ? '#888'
                    : BLUE,
                  borderRadius: '3px',
                  boxShadow: 'none',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                }}
              >
                {this.state.isVerifying ? 'Verifying...' : 'Continue'}
              </Button>
            </>
          )}
        </Box>

        {/* Footer tagline */}
        <Typography
          variant="caption"
          style={{
            color: 'rgba(255,255,255,0.4)',
            marginTop: '24px',
            fontSize: '0.7rem',
            letterSpacing: '0.5px',
          }}
        >
          ME-VISION · Purpose-Driven Individuals. Successful Leaders.
        </Typography>
      </Box>
    );
  }
}